export const STORE_CUSTOM_DOMAIN_QUERY_KEY = 'store-custom-domain';
